module.exports = __webpack_public_path__ + "static/media/CapaAppBoleto.180bf826.png";


//////////////////
// WEBPACK FOOTER
// ./src/Content/CapaAppBoleto.png
// module id = 193
// module chunks = 0